import { VFC } from 'react';
import { SensorScanStepContent } from './steps/sensor_scan/Content';
import { SensorConnectionStepContent } from './steps/sensor_connection_check/Content';
import { InstallMeterDetailStepContent } from './steps/installation_detail/Content';
import { PhotoStepContent } from './steps/photo/Content';
import { ReviewStepContent } from './steps/review/Content';
import { NotFoundContent } from '../not_found/components/NotFoundContent';
import { HardwaresStepContent } from './steps/hardwares/Content';
import { InstallationTechnologyStepContent } from './steps/installation_technology/Content';
import { InstallMeterStep } from './enums/installMeterStep';

const MAP = {
  [InstallMeterStep.InstallationTechnology]: InstallationTechnologyStepContent,
  [InstallMeterStep.SensorScan]: SensorScanStepContent,
  [InstallMeterStep.SensorConnection]: SensorConnectionStepContent,
  [InstallMeterStep.Hardwares]: HardwaresStepContent,
  [InstallMeterStep.InstallationDetail]: InstallMeterDetailStepContent,
  [InstallMeterStep.Photo]: PhotoStepContent,
  [InstallMeterStep.Review]: ReviewStepContent,
} satisfies Record<InstallMeterStep, VFC>;

export const getContentByStep = (newStep: InstallMeterStep): VFC => MAP[newStep] ?? NotFoundContent;
